import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { GroupForm } from "./GroupForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { FormToolbar } from "../../common/form/FormToolbar";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IGroupCreateProps {}

export const GroupEdit = (props: IGroupCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Group,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-groups.title.edit">
        <GroupForm
          toolbar={
            <FormToolbar
              showDeleteButton={
                permissions &&
                permissions[permissionNames.admin.groups.main] &&
                permissions[permissionNames.admin.groups.delete]
              }
            />
          }
        />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
